var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100vh"}},[_vm._v(" 啊哈哈哈哈 "),_c('el-dialog',{attrs:{"title":"提示","visible":_vm.dialog,"width":"30%","before-close":_vm.handleClose}},[_c('h3',[_vm._v("当前系统暂不支持该地域登录")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }